import Icon from '@atoms/Icon/Icon';
import { IconName } from '@models/IIcon';
import { ILink } from '@models/ILink';
import updateDataLayer from '@utils/helpers/gtm';

interface Props {
  readonly socialTitle?: string;
  readonly socialLinks: ILink[];
  readonly textClasses?: string;
  readonly dataTestId?: string;
}

const SocialLinks = ({
  socialTitle,
  socialLinks,
  textClasses = 'body-two',
  dataTestId = 'Social-Links',
}: Props) => (
  <div className="text-black-100 dark:text-white" data-testid={dataTestId}>
    {socialTitle && (
      <p className={textClasses} data-testid={`${dataTestId}-Social-Title`}>
        {socialTitle}
      </p>
    )}

    <div className="mt-4 flex flex-wrap gap-5">
      {socialLinks
        .filter((link) => link.url && link.linkIcon)
        .map(({ name = '', url = '', linkIcon, target = '' }) => (
          <a
            href={url}
            key={name}
            target={target}
            aria-label={name}
            onClick={() =>
              updateDataLayer({
                event: 'socialClick',
                platform: name || linkIcon,
              })
            }
            data-testid={`${dataTestId}-Social-Link`}
          >
            <Icon
              name={linkIcon as IconName}
              className="text-black-100 transition duration-300 ease-in-out hover:text-grey-450 dark:text-white dark:hover:text-yellow"
            />
          </a>
        ))}
    </div>
  </div>
);

export default SocialLinks;
